import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingCropPrimaryData } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import {
  FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW,
  FOOTPRINTING_CROP_DRYINGS,
  FOOTPRINTING_CROP_FERTILIZERS_MINERAL,
  FOOTPRINTING_CROP_FERTILIZERS_ORGANIC,
  FOOTPRINTING_CROP_PRIMARY_DATA,
  FOOTPRINTING_CROP_PURCHASERS,
  FOOTPRINTING_CROP_SALES,
  FOOTPRINTING_CROP_SEEDINGS,
  FOOTPRINTING_CROP_TILLAGES,
} from "consts";

export const useDeleteFootprintingCropByPrimaryDataId = (farmId: string, cropId: string, year: number, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
    mutationFn: () => (primaryDataId ? deleteFootprintingCropPrimaryData(primaryDataId) : Promise.resolve(null)),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        // All the extra keys clean up the mess of stuff from this now-deleted data
        [FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, farmId, isAdmin],
        [FOOTPRINTING_CROP_DRYINGS, primaryDataId, isAdmin],
        [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId, isAdmin],
        [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId],
        [FOOTPRINTING_CROP_PURCHASERS, farmId, isAdmin],
        [FOOTPRINTING_CROP_SALES, primaryDataId, isAdmin],
        [FOOTPRINTING_CROP_SEEDINGS, primaryDataId, isAdmin],
        [FOOTPRINTING_CROP_TILLAGES, primaryDataId, isAdmin],
        ...footprintingCropPrimaryQueryKeys(primaryDataId ?? "", farmId, cropId, year, isAdmin),
      ]);
    },
  });
};
